import { render, staticRenderFns } from "./sfc-enroll-now-button.vue?vue&type=template&id=2bb4c352&scoped=true&lang=pug&"
import script from "./sfc-enroll-now-button.vue?vue&type=script&lang=js&"
export * from "./sfc-enroll-now-button.vue?vue&type=script&lang=js&"
import style0 from "./sfc-enroll-now-button.vue?vue&type=style&index=0&id=2bb4c352&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4c352",
  null
  
)

export default component.exports